<template>
  <div>
    <LiveHeader />
    <span style="height: 60px" class="d-block"></span>
    <router-view></router-view>
  </div>
</template>

<script>
import LiveHeader from '../../components/LiveHeader';
import { log, setAuthKey, getAuthKey } from '../../app/helpers';

export default {
  components: {
    LiveHeader
  },

  data() {
    return  {
      
    }
  },


  beforeMount() {
    this.setKey();
  },


  mounted() {
    this.$store.commit('hasHeader', false);
  },


  methods: {
    setKey() {
      const __k = this.$route.query.__k;

      if (__k) {
        setAuthKey(__k);
      }
      
    }
  },


  watch: {
    $route() {
      this.$store.commit('hasHeader', false);
    }
  }
}
</script>


<style lang="scss" scoped>

</style>